import icon from './sentiment_score.png.js';
import template from './graph_widget_view.html';
import templateMaxView from './graph_widget_max.html';
import templateReportView from './graph_widget_report.html';

angular.module('MW.InsDashboard.AvgSentimentWidget',[
    'MW.Dashboard.DashboardWidgetService',
    'MW.InsDashboard.InsightsDataMaps',
    'MW.InsDashboard.TransformSentimentScore',
    'MW.Framework.TranslationService',
    'MW.InsDashboard.InsWidgetConfigService',
    'MW.InsDashboard.insightsBackendService',
    'MW.InsDashboard.ChartService',
    'DashboardChartConfigService',
    'MW.Framework.GeoService',
    'MW.Framework.CoreCommon',
    'CoreChartObject',
    'MW.InsDashboard.WidgetController',
    'MW.Configuration',
    'MW.Framework.CoreUserService'
])
.directive('avgSentimentWidget', [
    'DashboardWidgetService',
    '$controller',
    'ChartService',
    'InsightsDataMaps',
    'TransformSentimentScore',
    'translationService',
    'insightsBackendService',
    'DashboardChartConfigService',
    'GeoService',
    'InsWidgetConfigService',
    'CoreCommon',
    'CoreChartObject',
    '$filter',
    'CoreUserService',
    function(DashboardWidgetService, $controller, ChartService, InsightsDataMaps, TransformSentimentScore, translationService, insightsBackendService, DashboardChartConfigService, GeoService, InsWidgetConfigService, CoreCommon, CoreChartObject, $filter, CoreUserService){

    var avgSentimentWidget = DashboardWidgetService.getWidget('avg-sentiment-widget');

    var avgSentimentWidgetController = function($scope){
        $controller('WidgetController', {$scope: $scope});//inject the scope and use the basic widget controller
    };

    var avgSentimentWidgetLink = function(scope, element) {
        var getLabelVisibilityFromSettings = function getLabelVisibilityFromSettings() {
            return CoreCommon.isUsable(scope.widget.settings.labelVisibility) ? scope.widget.settings.labelVisibility[0].id : scope.widget.availableLabelVisibility[0].id;
        };
        scope.labelVisibility = (getLabelVisibilityFromSettings() == 1) ? false : true;

        var customData = {
            yAxis: {
                title: {
                    text: translationService.getLocalizedString('Sentiment Score')
                },
                min: -100,
                max: 100
            },
            plotOptions: {
                series: {
                    dataLabels: {
                        formatter: function lineChartLabelFormatter() {
                            return  DashboardChartConfigService.formatDataLabels(this.point.count || this.point.y.toFixed(2));
                        }
                    }
                }
            },
            tooltip: {
                shared: scope.widget.settings.dateComparison,
                formatter: function() {
                    if(scope.widget.settings.dateComparison) {
                        if(this.points.length > 1)
                            var deltaPercent = ((this.points[0].point.y - this.points[1].point.y) / this.points[1].point.y) * 100;
                        var s = '<div class="comparison-tooltip">';
                        $.each(this.points, function(i, point) {
                            s += '<div class="date"><b>' + $filter('mwConvertDateToUserTimezone')(point.point.date, 'fullDate')  + '</b></div>'
                            + '<div><div class="point" style="color:'+ point.point.series.color +'">\u25CF</div>'
                            + '<div class="volume">' + translationService.getLocalizedString('Score') + ': </div>'
                            + '<div class="volume"><b>' + Highcharts.numberFormat(point.point.y)
                            + '</b></div><div class="clearFix"></div></div>';
                        });
                        if(this.points.length > 1 && this.points[1].point.y > 0)
                            s += '<div class="change">'
                             + translationService.getLocalizedString('dashboard-widgets__graph-tooltip-change') + Highcharts.numberFormat(deltaPercent) + '%'
                             + '</div>';
                        s += '</div>'
                        return s;
                    } else {
                        var toolTipData = '',
                        currentValue = this.y;

                        toolTipData += '<b>' + this.series.name + '</b><br>' + translationService.getLocalizedString('Score') + ': '+ currentValue.toFixed(1) +'<br>';

                        //to get previous
                        if (this.series.data[this.point.x-1] !== undefined){
                            var previousValue = this.series.data[this.point.x-1].y,
                                change =  currentValue - previousValue;

                            toolTipData += translationService.getLocalizedString('Previous') + ': '+ previousValue.toFixed(1) +'<br>';
                            toolTipData += translationService.getLocalizedString('dashboard-widgets__graph-tooltip-change') + ' ' + change.toFixed(1) +'<br>';
                            if (previousValue != 0 && change != 0){
                                var percentage = (change/previousValue*100).toFixed(1);
                                if (previousValue<currentValue) {
                                    percentage*=-1;
                                }
                                toolTipData += translationService.getLocalizedString('dashboard-widgets__graph-tooltip-change-percent') + ' ' + percentage;
                            }
                        }
                        return toolTipData;
                    }
                }
            }
        };
        //Used to further customize the chart itself. Use sparingly as possible.
        //These are the switched off of the view defined in widget_ctrl, so if more views are added just update here as necessary to override
        var chartOverrides = {
            user: customData,
            max: customData,
            report: customData
        };

        //Used in core chart service to create the core chart.
        //update here as necessary to override or change
        var settingsOverides = {
            yAxisAbs: false, //used to make the values absolute
            fetchDataForPreviousRange: scope.widget.settings.dateComparison
        };

        var chartConfiguration = {
            insightsService: 'statisticServiceAvgDateHistogram',
            insightsObject: 'dateAverageSentimentHistograms',
            dataLabels: true,
            charts: {
                spline: {
                    chart: ChartService.line,
                    transform: TransformSentimentScore.chartByInput,
                    dataMap: InsightsDataMaps.datamapDateAverage,
                    custom: chartOverrides,
                    customSettings: settingsOverides
                },
                column: {
                    chart: ChartService.column,
                    transform: TransformSentimentScore.chartByInput,
                    dataMap: InsightsDataMaps.datamapDateAverage,
                    custom: chartOverrides,
                    customSettings: settingsOverides
                },
                table: {
                    chart: {},
                    transform: TransformSentimentScore.table,
                    dataMap: InsightsDataMaps.datamapDateAverage
                }
            },
            table: {
                enabled: true,
                rowTitle: translationService.getLocalizedString('Date'),
                summaryTitle: translationService.getLocalizedString('Total'),
                titleField: 'name',
                countField: 'average',
                percentField: 'sentiment_score',
                drilldown: function sentiment_score_table_drilldown(datapoint){
                    scope.internalDrillDown(datapoint.id, datapoint.date);
                },
                tooltip: function sentiment_score_table_tooltip(datapoint){
                    return translationService.getLocalizedString('Score: ') + datapoint.average;
                },
                customRowTitleSort: true
            }
        };

        if (scope.widget.settings && scope.widget.settings.previousDateRange && scope.widget.settings.dateComparison) {
            chartConfiguration['previousDateStart'] = moment(scope.widget.settings.previousDateRange.startDate).tz(CoreUserService.getTimezone()).format();
            chartConfiguration['previousDateEnd'] = moment(scope.widget.settings.previousDateRange.endDate).tz(CoreUserService.getTimezone()).format();
        }

        scope.initWidget(chartConfiguration);
    };

    return new WidgetDirective(avgSentimentWidget, avgSentimentWidgetLink, avgSentimentWidgetController);
}])
.run(['DashboardWidgetService', 'translationService', 'InsWidgetConfigService', 'DASHBOARD_LEGACY_URL', function (DashboardWidgetService, translationService, InsWidgetConfigService, DASHBOARD_LEGACY_URL) {
    DashboardWidgetService.register({
        name: translationService.getLocalizedString('Sentiment Score'),
        app: 'ins_dashboard',
        description: translationService.getLocalizedString( 'The Sentiment Score widget provides insight into how the general sentiment of a brand, ' +
                                                            'product, event or topic develops over time and at the same time benchmarks how the sentiment ' +
                                                            'is developing in the context of other brands. The widget can be used to benchmark up to 5 ' +
                                                            'different brands or products.'),
        directive:'avg-sentiment-widget',
        icon,
        defaultSettings: {
            'width': 'third',
            'title': 'Title',
            'description': '',
            source: [],
            'maxAgents': 5
        },
        displayOrder: 4,
        allowExport: true,
        availableFilters : [{name:'Country',id:'country'},{name:'Language',id:'language'}],
        availableSettings: ['dateRange', 'title', 'news', 'social','broadcast', 'rss','tags', 'chartType', 'labelFormat', 'dateBreakouts', 'dateComparison', 'labelVisibility'],
        availableChartTypes:[{name:'Line',id:'spline'}, {name:'Bar',id:'column'}],
        requiredSettings: ['dateRange'],
        getDefaultChartType: function() {
            return this.availableChartTypes[0];
        },
        hasRequiredSettings: function(){
            var _widget = this;
            return InsWidgetConfigService.hasSelectedAnInput(_widget);
        },
        template,
        templateMaxView,
        templateReportView
    });

}]);
